import { render, staticRenderFns } from "./PromotionAdd.vue?vue&type=template&id=6cc8d5d9&scoped=true&"
import script from "./PromotionAdd.vue?vue&type=script&lang=js&"
export * from "./PromotionAdd.vue?vue&type=script&lang=js&"
import style0 from "./PromotionAdd.vue?vue&type=style&index=0&id=6cc8d5d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc8d5d9",
  null
  
)

export default component.exports